<div class="menubar-hoverable header-fixed menubar-pin"
  style="font-family: 'Roboto', sans-serif, Helvetica, Arial, sans-serif;font-size: 13px;line-height: 1.846153846;color: #313534;background-color: #ffffff;">

  <!-- header -->
  <!--  -->

  <!-- BEGIN BASE-->
  <div id="base">

    <!-- BEGIN OFFCANVAS LEFT -->
    <div class="offcanvas">
    </div>
    <!--end .offcanvas-->
    <!-- END OFFCANVAS LEFT -->


    <!-- BEGIN CONTENT-->
    <div id="content">
      <section class="has-actions style-default-bright" style="padding: 0;">

        <div class="row">
          <div class="card-head" style="padding-top: 3em">
            <ul class="nav nav-tabs" data-toggle="tabs" style="padding: 0px 35px;">
              <li class="active"><a style="cursor: pointer;font-size: 11px;line-height: 35px;" data-target="#overview"
                  data-toggle="tab">{{ 'overview' | translate }}</a></li>
              <li
                *ngIf="(academicPermissions.STUDENT_RE_ACTIVATE == 'ENABLED' || academicPermissions.SETTINGS_MANAGEMENT == 'ENABLED')">
                <a style="cursor: pointer;font-size: 11px;line-height: 35px;" data-target="#activation"
                  data-toggle="tab" (click)="getDeactivatedStudentList()">{{'staff/studentActivation' | translate }}</a>
              </li>
              <li *ngIf="academicPermissions.SETTINGS_MANAGEMENT == 'ENABLED'"><a
                  style="cursor: pointer;font-size: 11px;line-height: 35px;" (click)="getUserList()" data-toggle="tab"
                  data-target="#userAdmin">{{ 'adminManagement' | translate }}</a></li>
              <li *ngIf="academicPermissions.SETTINGS_MANAGEMENT == 'ENABLED'"><a
                  style="cursor: pointer;font-size: 11px;line-height: 35px;" data-toggle="tab"
                  data-target="#bluewingFeatures">{{ 'featureManagement' | translate }}</a></li>
              <li *ngIf="academicPermissions.SETTINGS_MANAGEMENT == 'ENABLED'"><a
                  style="cursor: pointer;font-size: 11px;line-height: 35px;" data-toggle="tab"
                  data-target="#generalSettings">{{ 'generalSettings' | translate }}</a></li>
              <li *ngIf="academicPermissions.SETTINGS_MANAGEMENT == 'ENABLED'"><a
                  style="cursor: pointer;font-size: 11px;line-height: 35px;" (click)="getExamBoard()" data-toggle="tab"
                  data-target="#manageBoard">{{ 'manageBoard' | translate }}</a></li>
            </ul>
          </div>
          <!--end .card-head -->
          <div class="card-body tab-content">
            <!-- Overview -->
            <div class="tab-pane active" id="overview">
              <div class="col-md-12" style="padding: 20px 35px;">
                <div class="col-md-9">
                  <div class="col-md-2" style="padding: 0;">
                    <img src="{{schoolImage}}" class="img-responsive img-circle"
                      style="border: 1px solid #e6e6e6;padding: 5px 5px;width: 130px;">
                  </div>
                  <div class="col-md-10" style="padding: 5px 0px 0px 25px;">
                    <h3 class="text-primary"
                      style="text-transform: uppercase;color:rgb(88, 88, 88);font-weight: 900;letter-spacing: 1px;margin-bottom: 10px;">
                      {{schoolName}}</h3>
                    <p style="margin-bottom: 15px;line-height: 0;color: #828282;font-weight: 400;">{{ 'type' | translate }}: <span
                        style="font-weight: 400;background: #f9d61c;color: white;display: inline-block;line-height: 15px;padding: 0px 5px;font-size: 10px;">{{accountType}}</span>
                    </p>
                    <p style="margin-bottom: 15px;line-height: 0;color: #828282;font-weight: 400;"><i
                        class="fa fa-map-marker"></i> <span style="margin-right: 5px;"> {{address}}</span></p>
                  </div>
                </div>
                <div *ngIf="academicPermissions.EDIT_SCHOOL_PROFILE == 'ENABLED'" class="col-md-3 text-center"
                  style="padding: 40px 0px 0px 0px;">
                  <a style="text-decoration: none;outline: none;">
                    <button
                      style="margin: 0px 10px;background-color: #ffffff;border-color: var(--filter-dropdown-color);color: var(--filter-dropdown-color);box-shadow: none;"
                      type="button" class="btn ink-reaction btn-floating-action btn-primary"
                      (click)="editInfoOffcanvas()"><i class="fa fa-pencil"></i></button>
                  </a>
                </div>
              </div>
              <div class="row"
                style="margin: 0;background: #f5f5f5;padding: 20px 0px 0px 0px;border: 1px solid #dadada;">

                <div class="col-md-4">
                  <div class="card" style="border-bottom: 3px solid #F44336;padding-top: 5px;">
                    <h1 class="pull-right" style="color: #969696;margin-right: 15px;margin-top: 0;"><i
                        class="fa fa-user-times"></i></h1>
                    <div style="padding: 0px 20px;">
                      <h2 style="margin: 0;margin-top: 25px;">{{InactiveStaff}}</h2>
                      <p style="color: #8c8c8c;">{{ 'deactiveStaffs' | translate }}</p>

                      <strong>{{ActiveStaff}}</strong> {{ 'activeStaffs' | translate }}
                      <!--<span class="pull-right text-success text-sm">0,18% <i class="md md-trending-up"></i></span>-->
                      <div class="progress progress-hairline">
                        <div class="progress-bar progress-bar-primary-dark" style="width:0%"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="card" style="border-bottom: 3px solid #4CAF50;padding-top: 5px;">
                    <h1 class="pull-right" style="color: #969696;margin-right: 15px;margin-top: 0;"><i
                        class="fa fa-graduation-cap"></i></h1>
                    <div style="padding: 0px 20px;">
                      <h2 style="margin: 0;margin-top: 25px;">{{InactiveStudent}}</h2>
                      <p style="color: #8c8c8c;">{{ 'deactiveStudents' | translate }}</p>

                      <strong>{{ActiveStudent}}</strong> {{ 'activeStudents' | translate }}
                      <!--<span class="pull-right text-success text-sm">0,21% <i class="md md-trending-up"></i></span>-->
                      <div class="progress progress-hairline">
                        <div class="progress-bar progress-bar-primary-dark" style="width:0%"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="card" style="border-bottom: 3px solid #FFEB3B;padding-top: 5px;">
                    <h1 class="pull-right" style="color: #969696;margin-right: 15px;margin-top: 0;"><i
                        class="fa fa-bolt"></i></h1>
                    <div style="padding: 0px 20px;">
                      <h2 style="margin: 0;margin-top: 25px;">{{Employee}}</h2>
                      <p style="color: #8c8c8c;">{{ 'deactiveAdminUsers' | translate }}</p>

                      <strong>{{AdminUser}}</strong> {{ 'activeAdminUsers' | translate }}
                      <!--<span class="pull-right text-success text-sm">0,18% <i class="md md-trending-up"></i></span>-->
                      <div class="progress progress-hairline">
                        <div class="progress-bar progress-bar-primary-dark" style="width:0%"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" style="margin: 20px 0px 0px 0px;">
                <div class=" card col-md-12" style="padding: 0px 15px 25px 15px;">
                  <div class="col-md-6">
                    <h3>{{ 'info' | translate }}</h3>
                    <p class="opacity-75">{{description}}</p>
                    <div class="">
                      <div class="clearfix opacity-75">
                        <div class="col-md-6" style="padding: 0;font-size: 15px;padding-bottom: 10px;">
                          <span class="glyphicon glyphicon-phone text-sm"></span> &nbsp;{{phoneNumber}}
                        </div>
                        <div class="col-md-6"
                          style="padding: 0;font-size: 15px;padding-bottom: 10px;margin-left: -105px;">
                          <span class="glyphicon glyphicon-envelope text-sm"></span> &nbsp;{{emailId}}
                        </div>
                      </div>
                      <div class="clearfix">
                        <div class="col-lg-12" style="padding: 0;font-size: 15px;padding-bottom: 10px;">
                          <span class="opacity-75"><span class="glyphicon glyphicon-map-marker text-sm"></span>
                            &nbsp;{{address}}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <h3>{{ 'chatLimits' | translate }}</h3>
                    <strong>{{ 'staffChatLimit' | translate }}</strong>
                    <span class="pull-right text-success text-sm">{{staffChatMessageLimit}}</span>
                    <div class="progress progress-hairline">
                      <div class="progress-bar progress-bar-primary-dark" style="width:0%"></div>
                    </div>

                    <strong>{{ 'parentChatLimit' | translate }}</strong>
                    <span class="pull-right text-success text-sm">{{parentChatMessageLimit}}</span>
                    <div class="progress progress-hairline">
                      <div class="progress-bar progress-bar-primary-dark" style="width:0%"></div>
                    </div>

                  </div>
                </div>
              </div>
            </div>

            <!-- Activation -->
            <div class="tab-pane" id="activation">
              <div class="col-md-12">

                <!--<button (click)="drawch()">check</button>-->

                <div class="card tabs-left style-default-light">
                  <ul class="card-head nav nav-tabs" data-toggle="tabs">
                    <li class="active"><a style="cursor: pointer;" data-target="#account" data-toggle="tab">{{ 'account' | translate }}</a>
                    </li>
                    <li
                      *ngIf="(academicPermissions.STUDENT_RE_ACTIVATE == 'ENABLED' || academicPermissions.SETTINGS_MANAGEMENT == 'ENABLED')">
                      <a style="cursor: pointer;" data-target="#students" data-toggle="tab"
                        (click)="getDeactivatedStudentList()">{{ 'deactivatedStudents' | translate }}</a>
                    </li>
                    <li
                      *ngIf="(academicPermissions.DEACTIVATE == 'ENABLED'  || academicPermissions.SETTINGS_MANAGEMENT == 'ENABLED')">
                      <a style="cursor: pointer;" data-target="#staffs" data-toggle="tab"
                        (click)="onDeactivatedStaffTabClick()">{{ 'deactivatedStaffs' | translate }}</a>
                    </li>
                  </ul>
                  <div class="card-body tab-content style-default-bright">
                    <div class="tab-pane active" id="account">

                      <!-- <div class="row" style="margin: 0;padding: 10px 10px;">
                                  <h2 style="font-weight: 100;color: #a5a5a5;margin: 0;display: inline-block;border-bottom: 1px solid #dedede;padding-bottom: 5px;">Account status</h2>
                              </div> -->

                      <div class="row">
                        <div class="col-md-6">
                          <div id="container" style="margin: 0 auto"></div>
                        </div>
                        <div class="col-md-6" style="margin-left: -22em;">
                          <h3>{{ 'accountStatus' | translate }}</h3>
                          <ul style="list-style: none;margin-top: 20px;">
                            <li>
                              <h4 style="color: #737373;font-weight: 100;"><i class="fa fa-circle"
                                  style="font-size: 10px;margin-right: 10px;  color: #0f487f;"></i>
                                {{ 'activeStudents' | translate }}: <span style="font-weight: 400;">{{ActiveStudent}}</span></h4>
                            </li>
                            <li>
                              <h4 style="color: #737373;font-weight: 100;"><i class="fa fa-circle"
                                  style="font-size: 10px;margin-right: 10px;  color: #346da4;"></i>
                                {{ 'deactiveStudents' | translate }}: <span style="font-weight: 400;">{{InactiveStudent}}</span></h4>
                            </li>
                            <li>
                              <h4 style="color: #737373;font-weight: 100;"><i class="fa fa-circle"
                                  style="font-size: 10px;margin-right: 10px;  color: #5891c8;"></i>
                                {{ 'activeStaffs' | translate }}: <span style="font-weight: 400;">{{ActiveStaff}}</span></h4>
                            </li>
                            <li>
                              <h4 style="color: #737373;font-weight: 100;"><i class="fa fa-circle"
                                  style="font-size: 10px;margin-right: 10px;  color: #7cb5ec;"></i>
                                {{ 'deactiveStaffs' | translate }}: <span style="font-weight: 400;">{{InactiveStaff}}</span></h4>
                            </li>
                          </ul>
                        </div>
                      </div>

                      <div class="row" style="margin: 0;margin-top: -15em;">
                        <!--<button style="background-color: #026abf;border-color: #026abf;" type="button" class="pull-right btn ink-reaction btn-raised btn-primary" data-toggle="modal" data-target="#deactivateModal">Deactivate Account</button>-->
                      </div>
                    </div>

                 <div class="tab-pane" id="students">
                  <h3 style="text-align: center;font-weight:300;margin: 0 0 6rem;">{{ 'listOfDeactivatedStudentsForTheAcademicYear' | translate }}
                        <span style="color: var(--filter-dropdown-color)">
                          <select [(ngModel)]="academicInfo.current_academic" (change)="academicChanged()"
                            style="border:none">
                            <option [ngValue]="null">{{ 'all' | translate }}</option>
                            <option *ngFor="let ac of academicInfo.academicList" [ngValue]="ac.pkAcademicId">
                              {{ ac.Year }}{{ac.current ? ('current'|translate):''}}
                            </option>
                          </select>
                        </span>

                      </h3>
  
     <div  style="margin-top: -2em; margin-bottom: 1em; display: flex; flex-direction:row; justify-content: space-between;">

         <div>
        <label class="mb-0 mr-2">{{ 'Show' | translate }}</label>
        <select class="form-control" [(ngModel)]="pageSizeStudent" (change)="onPageSizeChangeForStudent()" style="width: auto; display: inline-block;">
          <option *ngFor="let size of pageSizeOptions" [value]="size">{{size}}</option>
        </select>
        <span class="ml-2">{{ 'entries' | translate }}</span>
        </div>

        <input 
          type="text" 
          class="form-control" 
          [(ngModel)]="searchStudentTerm" 
          (input)="onSearchStudentInput($event.target.value)"
          [placeholder]="'search' | translate" 
          style="border-left: 0; width:200px">
        </div> 

       <div class="page-loader-container" *ngIf="isPageLoading">
        <app-new-loader></app-new-loader>
      </div>
  
    <div class="table-responsive" style="margin-top: -1em;" *ngIf="!isPageLoading">
    <table class="table table-striped table-hover">
  <thead>
    <tr>
      <th (click)="sortStudentTable('studentName')" style="cursor: pointer;">
        {{ 'studentName' | translate }}
        <i *ngIf="currentSortBy === 'studentName'" 
           [class]="currentSortOrder === 'ASC' ? 'fa fa-sort-up' : 'fa fa-sort-down'"></i>
        <i *ngIf="currentSortBy !== 'studentName'" class="fa fa-sort" style="opacity: 0.3;"></i>
      </th>
      <th (click)="sortStudentTable('parentName')" style="cursor: pointer;">
        {{ 'parentName' | translate }}
        <i *ngIf="currentSortBy === 'parentName'" 
           [class]="currentSortOrder === 'ASC' ? 'fa fa-sort-up' : 'fa fa-sort-down'"></i>
        <i *ngIf="currentSortBy !== 'parentName'" class="fa fa-sort" style="opacity: 0.3;"></i>
      </th>
      <th (click)="sortStudentTable('mobileNumber')" style="cursor: pointer;">
        {{ 'mobileNumber' | translate }}
        <i *ngIf="currentSortBy === 'mobileNumber'" 
           [class]="currentSortOrder === 'ASC' ? 'fa fa-sort-up' : 'fa fa-sort-down'"></i>
        <i *ngIf="currentSortBy !== 'mobileNumber'" class="fa fa-sort" style="opacity: 0.3;"></i>
      </th>
      <th (click)="sortStudentTable('regId')" style="cursor: pointer;">
        {{ 'registrationId' | translate }}
        <i *ngIf="currentSortBy === 'regId'" 
           [class]="currentSortOrder === 'ASC' ? 'fa fa-sort-up' : 'fa fa-sort-down'"></i>
        <i *ngIf="currentSortBy !== 'regId'" class="fa fa-sort" style="opacity: 0.3;"></i>
      </th>
      <th (click)="sortStudentTable('class')" style="cursor: pointer;">
        {{ 'class' | translate }}
        <i *ngIf="currentSortBy === 'class'" 
           [class]="currentSortOrder === 'ASC' ? 'fa fa-sort-up' : 'fa fa-sort-down'"></i>
        <i *ngIf="currentSortBy !== 'class'" class="fa fa-sort" style="opacity: 0.3;"></i>
      </th>

      <th (click)="sortStudentTable('academicYear')" style="cursor: pointer;">
        {{ 'academicYear' | translate }}
        <i *ngIf="currentSortBy === 'academicYear'" 
           [class]="currentSortOrder === 'ASC' ? 'fa fa-sort-up' : 'fa fa-sort-down'"></i>
        <i *ngIf="currentSortBy !== 'academicYear'" class="fa fa-sort" style="opacity: 0.3;"></i>
      </th>

      <th (click)="sortStudentTable('deactivationDate')" style="cursor: pointer;">
        {{ 'deactivationDate' | translate }}
        <i *ngIf="currentSortBy === 'deactivationDate'" 
           [class]="currentSortOrder === 'ASC' ? 'fa fa-sort-up' : 'fa fa-sort-down'"></i>
        <i *ngIf="currentSortBy !== 'deactivationDate'" class="fa fa-sort" style="opacity: 0.3;"></i>
      </th>

        <th (click)="sortStudentTable('reason')" style="cursor: pointer;">
        {{ 'reason' | translate }}
        <i *ngIf="currentSortBy === 'reason'" 
           [class]="currentSortOrder === 'ASC' ? 'fa fa-sort-up' : 'fa fa-sort-down'"></i>
        <i *ngIf="currentSortBy !== 'reason'" class="fa fa-sort" style="opacity: 0.3;"></i>
      </th>

        <th (click)="sortStudentTable('deactivatedBy')" style="cursor: pointer;">
        {{ 'deactivatedBy' | translate }}
        <i *ngIf="currentSortBy === 'deactivatedBy'" 
           [class]="currentSortOrder === 'ASC' ? 'fa fa-sort-up' : 'fa fa-sort-down'"></i>
        <i *ngIf="currentSortBy !== 'deactivatedBy'" class="fa fa-sort" style="opacity: 0.3;"></i>
      </th>

      <th>{{ 'manage' | translate }}</th>
    </tr>
  </thead>
  <tbody>
      <ng-container *ngIf="studentList.length > 0; else noData">
            <tr class="gradeX" *ngFor="let inact of studentList">
              <td>{{inact.studentName}}</td>
              <td>{{inact.parentName}}</td>
              <td>{{inact.mobileNumber}}</td>
              <td>{{inact.registrationId}}</td>
              <td>{{inact.classNumber}} - {{inact.classDivision}}</td>
              <td>{{inact.Year}}</td>
              <td>{{inact.deactivatedDate | date : 'dd-MMM-yyyy'}}</td>
              <td>{{inact.reason}}</td>
              <td>{{inact.username || '-'}}</td>
              <td>
                <button type="button" (click)="reactivateStudentDetails(inact, 'STUDENT')"
                  class="reactive btn ink-reaction btn-raised btn-xs btn-primary" 
                  data-toggle="modal" data-target="#reactivateModal">{{ 'activate' | translate }}
                </button>
              </td>
            </tr>
          </ng-container>
    <ng-template #noData>
      <tr>
        <td colspan="10" class="text-center">
          <div style="padding: 2em;">
            <p style="margin-top: 1em; color: #666;">
              {{ searchStudentTerm ? ('noSearchResults' | translate) : ('noDataAvailable' | translate) }}
            </p>
          </div>
        </td>
      </tr>
    </ng-template>
  </tbody>
</table>

    </div>
    <div *ngIf="!isPageLoading && totalRecordsStudent > 0" class="row">

  <div class="pagination-info">
  <p class="text-muted mb-0" *ngIf="isStudentSearch; else normalPagination">
   {{ 'showingEntriesStudents' | translate: {start: searchStartStudent, end: searchEndStudent, total: searchLengthStudent} }}
  </p>
  
  <ng-template #normalPagination>
    <p class="text-muted mb-0">
     {{ 'showingEntriesStudents' | translate: {start: startIndexStudent, end: endIndexStudent, total: totalRecordsStudent} }}
    </p>
  </ng-template>
</div>

  <div class="col-xs-12 col-sm-12 col-md-2 col-md-offset-10 text-center text-md-right" style="padding-right: 0;" *ngIf="totalPages > 1">
  <nav aria-label="Page navigation">
    <ul class="pagination mb-0" style="margin: 0;display: inline-block;">
      <li class="page-item" [class.disabled]="!hasPreviousPage">
        <a class="page-link" (click)="previousPageStudent()" style="cursor: pointer;">
          {{ 'Previous' | translate }}
        </a>
      </li>
      <ng-container *ngFor="let page of visiblePages">
        <li *ngIf="page === 0" class="page-item disabled">
          <span class="page-link">...</span>
        </li>
        
        <li *ngIf="page !== 0" 
            class="page-item" 
            [class.active]="page === currentPage">
          <a class="page-link" (click)="goToPageStudent(page)" style="cursor: pointer;">
            {{page}}
          </a>
        </li>
      </ng-container>

      <li class="page-item" [class.disabled]="!hasNextPage">
        <a class="page-link" (click)="nextPageStudent()" style="cursor: pointer;">
          {{ 'Next' | translate }}
        </a>
      </li>
    </ul>
  </nav>
</div>
</div>

 
</div>

    <div class="tab-pane" id="staffs">
      <div class="col-lg-12">
        <div class="text-center" style="margin-left: -6em;">
          <h4 style="display: inline-block;font-weight: bolder;color: #6b6d64;padding: 10px 15px;font-size: large;">
            {{ 'listOfDeactivatedStaffs' | translate }}
          </h4>
        </div>
        <div
          style="margin-top: -2em; margin-bottom: 1em; display: flex; flex-direction:row; justify-content: space-between;">
          <div>
            <label class="mb-0 mr-2">{{ 'Show' | translate }}</label>
            <select class="form-control" [(ngModel)]="pageSize" (change)="onPageSizeChange()"
              style="width: auto; display: inline-block;">
              <option *ngFor="let size of pageSizeOptions" [value]="size">{{size}}</option>
            </select>
            <span class="ml-2">{{ 'entries' | translate }}</span>
          </div>
    
          <input type="text" class="form-control" [(ngModel)]="searchTerm" (input)="onSearchInput($event.target.value)"
            [placeholder]="'search' | translate" style="border-left: 0; width:200px">
        </div>
    
        <div class="page-loader-container" *ngIf="isPageLoading">
          <app-new-loader></app-new-loader>
        </div>
        <div class="table-responsive" style="margin-top: -1em;" *ngIf="!isPageLoading">
          <table class="table table-striped table-hover">
            <thead>
              <tr>
                <th (click)="sortStaffTable('staffName')" style="cursor: pointer;">
                  {{ 'staffName' | translate }}
                  <i *ngIf="currentSortBy === 'staffName'"
                    [class]="currentSortOrder === 'ASC' ? 'fa fa-sort-up' : 'fa fa-sort-down'"></i>
                  <i *ngIf="currentSortBy !== 'staffName'" class="fa fa-sort" style="opacity: 0.3;"></i>
                </th>
                <th (click)="sortStaffTable('mobileNumber')" style="cursor: pointer;">
                  {{ 'mobileNumber' | translate }}
                  <i *ngIf="currentSortBy === 'mobileNumber'"
                    [class]="currentSortOrder === 'ASC' ? 'fa fa-sort-up' : 'fa fa-sort-down'"></i>
                  <i *ngIf="currentSortBy !== 'mobileNumber'" class="fa fa-sort" style="opacity: 0.3;"></i>
                </th>
                <th (click)="sortStaffTable('designation')" style="cursor: pointer;">
                  {{ 'departmnt' | translate }}
                  <i *ngIf="currentSortBy === 'designation'"
                    [class]="currentSortOrder === 'ASC' ? 'fa fa-sort-up' : 'fa fa-sort-down'"></i>
                  <i *ngIf="currentSortBy !== 'designation'" class="fa fa-sort" style="opacity: 0.3;"></i>
                </th>
                <th (click)="sortStaffTable('Year')" style="cursor: pointer;">
                  {{ 'academicYear' | translate }}
                  <i *ngIf="currentSortBy === 'Year'"
                    [class]="currentSortOrder === 'ASC' ? 'fa fa-sort-up' : 'fa fa-sort-down'"></i>
                  <i *ngIf="currentSortBy !== 'Year'" class="fa fa-sort" style="opacity: 0.3;"></i>
                </th>
                <th (click)="sortStaffTable('deactivatedDate')" style="cursor: pointer;">
                  {{ 'deactivationDate' | translate }}
                  <i *ngIf="currentSortBy === 'deactivatedDate'"
                    [class]="currentSortOrder === 'ASC' ? 'fa fa-sort-up' : 'fa fa-sort-down'"></i>
                  <i *ngIf="currentSortBy !== 'deactivatedDate'" class="fa fa-sort" style="opacity: 0.3;"></i>
                </th>
                <th (click)="sortStaffTable('reason')" style="cursor: pointer;">
                  {{ 'reason' | translate }}
                  <i *ngIf="currentSortBy === 'reason'"
                    [class]="currentSortOrder === 'ASC' ? 'fa fa-sort-up' : 'fa fa-sort-down'"></i>
                  <i *ngIf="currentSortBy !== 'reason'" class="fa fa-sort" style="opacity: 0.3;"></i>
                </th>
                <th>{{ 'manage' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngIf="staffList.length > 0; else noData">
                <tr class="gradeX" *ngFor="let inactstaff of staffList">
                  <td>{{inactstaff.staffName}}</td>
                  <td>{{inactstaff.mobileNumber}}</td>
                  <td>{{inactstaff.designation}}</td>
                  <td>{{inactstaff.Year}}</td>
                  <td>{{inactstaff.deactivatedDate | date : 'y-MMM-d'}}</td>
                  <td>{{inactstaff.reason}}</td>
                  <td>
                    <button type="button" (click)="reactivateStaffDetails(inactstaff,'STAFF')"
                      class="reactive btn ink-reaction btn-raised btn-xs btn-primary" data-toggle="modal"
                      data-target="#reactivateModal">
                      {{ 'activate' | translate }}
                    </button>
                  </td>
                </tr>
              </ng-container>
    
              <ng-template #noData>
                <tr>
                  <td colspan="7" class="text-center">
                    <div style="padding: 2em;">
                      <p style="margin-top: 1em; color: #666;">
                        {{ searchTerm ? ('noSearchResults' | translate) : ('noDataAvailable' | translate) }}
                      </p>
                    </div>
                  </td>
                </tr>
              </ng-template>
            </tbody>
          </table>
    
        </div>
        <div *ngIf="!isPageLoading && totalRecords > 0" class="row">

          <div class="pagination-info">
  <p class="text-muted mb-0" *ngIf="isSearch; else normalPagination">
   {{ 'showingEntries' | translate: {start: searchStartIndex, end: searchEndIndex, total: searchLength} }}
  </p>
  
  <ng-template #normalPagination>
    <p class="text-muted mb-0">
      {{ 'showingEntries' | translate: {start: startIndex, end: endIndex, total: totalRecords} }}
    </p>
  </ng-template>
</div>
    
          <div class="col-xs-12 col-sm-12 col-md-2 col-md-offset-10 text-center text-md-right" style="padding-right: 0;"
            *ngIf="totalPages > 1">
            <nav aria-label="Page navigation">
              <ul class="pagination mb-0" style="margin: 0;display: inline-block;">
                <li class="page-item" [class.disabled]="!hasPreviousPage">
                  <a class="page-link" (click)="previousPage()" style="cursor: pointer;">
                    {{ 'Previous' | translate }}
                  </a>
                </li>
    
                <ng-container *ngFor="let page of visiblePages">
                  <li *ngIf="page === 0" class="page-item disabled">
                    <span class="page-link">...</span>
                  </li>
    
                  <li *ngIf="page !== 0" class="page-item" [class.active]="page === currentPage">
                    <a class="page-link" (click)="goToPage(page)" style="cursor: pointer;">
                      {{page}}
                    </a>
                  </li>
                </ng-container>
    
                <li class="page-item" [class.disabled]="!hasNextPage">
                  <a class="page-link" (click)="nextPage()" style="cursor: pointer;">
                    {{ 'Next' | translate }}
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
    
      </div>
    </div>         
                  </div>
                  <!--end .card-body -->
                </div>
                <!--end .card -->
              </div>
              <!--end .col -->
            </div>
            <!--Admin Management-->
            <div id="userAdmin" class="card tab-pane" *ngIf="academicPermissions.SCHOOL_ADMIN_MANAGES == 'ENABLED'"
              style="padding: 0;">
              <div class="col-md-12" style="border-bottom: 1px solid #e2e2e2;    padding: 0px 20px;">
                <h3 class="pull-left" style="font-weight: 400;color: #505050;">{{ 'adminUsers' | translate }} <span
                    style="margin-left: 5px;color: #5a5a5a;"><i class="fa fa-street-view"></i></span></h3>
                <button style="background-color: var(--tertiary-btn-bg-color);margin-top: 25px;border-color: var(--tertiary-btn-bg-color);" type="button"
                  (click)="openPopUp()" class="pull-right btn ink-reaction btn-raised btn-xs btn-primary"
                  data-toggle="modal" data-target="#addUserModal">{{ 'addUser' | translate }}
                </button>
              </div>
              <div [style.display]="userlst.length > 0 ? 'none':''" class="col-md-12 text-center"
                style="color: var(--brand-primary-color);padding-top: 5em;">
                <h3>{{ 'noAdminAreAvailable' | translate }}</h3>
              </div>
              <div class="table-responsive" [style.display]="userlst.length > 0 ? '':'none'"
                style="padding: 15px 15px;">
                <table id="userAdmin-table" class="table table-striped">
                  <thead>
                    <tr>
                      <th>{{ 'userName' | translate }}</th>
                      <th>{{ 'userType' | translate }}</th>
                      <th>{{ 'userEmailId' | translate }}</th>
                      <th>{{ 'mobileNumber' | translate }}</th>
                      <th>{{ 'lastLoggedInTime' | translate }}</th>
                      <th>{{ 'status' | translate }}</th>
                      <th>{{ 'manage' | translate }}</th>
                      <th *ngIf="getAdminType == 'SUPER_ADMIN'">{{ 'changePassword' | translate }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="gradeX" *ngFor="let user of userlst">
                      <td>{{user.username}}</td>
                      <td>{{user.AccessType}}</td>
                      <td>{{user.emailId}}</td>
                      <td>{{user.adminPhoneNumber}}</td>
                      <td>{{user.LastLoggedOn }}</td>
                      <td>
                        <p
                          style="background: #dadada;color: white;display: inline-flex;padding: 0px 15px;text-transform: uppercase;border-radius: 20px;font-size: 10px;">
                          {{user.isBlocked == 0 ? 'Active':'Inactive'}}</p>
                      </td>
                      <td>
                        <a [style.display]="user.isBlocked == 0 ? '':'none'"
                          class="btn btn-flat ink-reaction btn-default" data-toggle="modal" data-target="#editUserModal"
                          (click)="adminUserPopUpExistingDetails(user,true);"><i class="fa fa-edit"></i></a>
                        <a class="btn btn-flat ink-reaction" [style.display]="user.isBlocked == 0 ? '':'none'"
                          data-toggle="modal" data-target="#deleteusermodal" (click)="deleteuserid(user)"><i
                            class="fa fa-trash"></i></a>
                        <button type="button" [style.display]="user.isBlocked == 1 ? '':'none'" data-toggle="modal"
                          data-target="#activateAdmin" (click)="activateUser(user)"
                          class="reactive btn ink-reaction btn-raised btn-xs btn-primary">{{ 'activate' | translate }}
                        </button>
                      </td>
                      <td>
                        <a [style.display]="user.isBlocked == 0 ? '':'none'" href="#"
                          *ngIf="getAdminType == 'SUPER_ADMIN'" style="cursor:pointer;color: #039be5;"
                          data-toggle="modal" data-target="#ChangePasswordModal"
                          (click)="selectedUserIdToChangePswd(user)">{{ 'changePassword' | translate }}</a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <!--Feature Management-->
            <div id="bluewingFeatures" class="tab-pane">
              <div class="card features-main-card">

                <!-- Header -->
                <div class="features-header d-flex flex-column flex-md-row justify-content-between align-items-center">
                  <h3 class="features-header-title">
                    {{ 'schoolFeatures' | translate }}
                  </h3>
                  <div class="search-and-filter-for-feature">
                     <div class="status-filter-wrapper  ">
                      <label class="status-label-for-feature">{{ 'status' | translate }}:</label>
                      <p-dropdown 
                        [options]="statusFilterOptions" 
                        [(ngModel)]="selectedStatusFilter" 
                        (onChange)="onStatusFilterChange()"
                        optionLabel="label" 
                        optionValue="value"
                          styleClass="custom-dropdown-feature-status-filter"
                        [style]="{'width': '150px', 'min-width': '150px','padding' : '6px', 'border-radius': '10px'}">
                      </p-dropdown>
                    </div>
                    <div class="search-input-wrapper">
                      <i class="fa fa-search"></i>
                      <input type="text" (input)="onSearchFeatureInput($event.target.value.trimStart())"
                        [placeholder]="'search' | translate" class="premium-search" />
                    </div>
                    </div>

                   
          
                </div>

                <div class="page-loader-container" *ngIf="isPageLoading">
                  <app-new-loader></app-new-loader>
                </div>

                <div class="features-container-card" *ngIf="!isPageLoading">
                  <p-table [value]="filteredFeatures" [paginator]="true" [rows]="pageSizeFeature"
                    [first]="(currentPageFeature - 1) * pageSizeFeature" [rowHover]="true" responsiveLayout="scroll"
                    [stripedRows]="true" [sortField]="featureSortField" [sortOrder]="featureSortOrder"
                    (onSort)="onFeatureTableSort($event)">


                    <ng-template pTemplate="header">
                      <tr>
                        <th pSortableColumn="BluewingsFeatureDescription" class="features-col-name">
                          {{ 'featuresName' | translate }} <p-sortIcon field="BluewingsFeatureDescription"></p-sortIcon>
                        </th>
                        <th pSortableColumn="ActiveStatus" class="features-col-status">{{ 'status' | translate }}
                          <p-sortIcon field="ActiveStatus"></p-sortIcon></th>
                        <th class="text-center features-col-action">{{ 'action' | translate }}</th>
                      </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-flist let-i="rowIndex">
                      <tr>
                        <!-- 1. Feature Name -->
                        <td class="feature-description-cell">{{flist.BluewingsFeatureDescription}}</td>

                        <!-- 2. Status Pill -->
                        <td>
                          <p-chip
                            [label]="flist.ActiveStatus == 'ENABLED' ? ('enabled' | translate) : ('disabled' | translate)"
                            [styleClass]="'status-pill ' + (flist.ActiveStatus == 'ENABLED' ? 'status-enabled' : 'status-disabled')">
                          </p-chip>
                        </td>

                        <!-- 3. Toggle Switch -->
                        <td class="text-center">
                          <div *ngIf="flist.FeatureEditableStatus == 'EDITABLE'" class="switch-container">
                            <p-inputSwitch [ngModel]="flist.ActiveStatus == 'ENABLED'" [disabled]="flist.loading"
                              (onChange)="updateFeatureList(flist, $event.checked ? 'ENABLED' : 'DISABLED', i)">
                            </p-inputSwitch>
                            <i *ngIf="flist.loading" class="fa fa-spinner fa-spin ml-2 switch-container-loader"
                              class="feature-switch-spinner"></i>
                          </div>
                          <div *ngIf="flist.FeatureEditableStatus != 'EDITABLE'">
                            <span class="text-muted feature-trial-info">
                              {{ 'notAvailableForTrailSubscription' | translate }}
                            </span>
                          </div>
                        </td>
                      </tr>
                    </ng-template>

                    <!-- Empty State -->
                    <ng-template pTemplate="emptymessage">
                      <tr>
                        <td colspan="3" class="text-center py-5">
                          <div class="empty-feature-list">
                            <i class="fa fa-search-minus fa-3x text-muted mb-3 d-block"></i>
                            <span class="text-muted font-italic">{{ 'noSearchResults' | translate }}</span>
                          </div>
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>

                  <!-- Custom Pagination Block -->
                  <div *ngIf="!isPageLoading"
                    class="custom-pagination-container d-flex flex-column flex-md-row justify-content-between align-items-center p-3">
                    <div class="pagination-left d-flex align-items-center mb-3 mb-md-0">
                      <div class="entries-selector mr-3">
                        <label class="mb-0 mr-2">{{ 'Show' | translate }}</label>
                        <select class="form-control d-inline-block feature-entries-select" [(ngModel)]="pageSizeFeature"
                          (change)="onPageSizeChangeForFeature()">
                          <option *ngFor="let size of pageSizeOptions" [value]="size">{{size}}</option>
                        </select>
                        <span class="ml-2">{{ 'entries' | translate }}</span>
                      </div>
                      <div class="pagination-info">
                        <p class="text-muted mb-0">
                          {{ 'showingEntriesStudents' | translate: {start: startIndexFeature, end: endIndexFeature,
                          total: totalRecordsFeature} }}
                        </p>
                      </div>
                    </div>

                    <div class="pagination-controls" *ngIf="totalPagesFeature > 1">
                      <nav aria-label="Page navigation">
                        <ul class="pagination mb-0 feature-pagination-list">
                          <li class="page-item" [class.disabled]="!hasPreviousPageFeature">
                            <a class="page-link feature-page-link" (click)="previousPageFeature()">
                              <i class="fa fa-angle-left"></i>
                            </a>
                          </li>

                          <ng-container *ngFor="let page of visiblePagesFeature">
                            <li *ngIf="page === 0" class="page-item disabled">
                              <span class="page-link">...</span>
                            </li>
                            <li *ngIf="page !== 0" class="page-item" [class.active]="page === currentPageFeature">
                              <a class="page-link feature-page-link" (click)="goToPageFeature(page)">
                                {{page}}
                              </a>
                            </li>
                          </ng-container>

                          <li class="page-item" [class.disabled]="!hasNextPageFeature">
                            <a class="page-link feature-page-link" (click)="nextPageFeature()">
                              <i class="fa fa-angle-right"></i>
                            </a>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- General settings -->
            <div class="tab-pane" id="generalSettings">
              <div class="row card col-md-12" style="margin: 20px 0px 0px 0px;">
                <div class="clearfix" style="padding-top: 30px">
                  <div class="col-md-6" style="padding: 0;font-size: small;padding-bottom: 10px;">
                    {{ 'generateStudentRegistrationNumberAutomaticManual' | translate }}
                  </div>
                  <div class="col-md-6" style="padding: 0;font-size: 15px;padding-bottom: 10px;margin-left: -105px;">
                    <div class="checkbox checkbox-styled">
                      <label>
                        <input [disabled]="isProcessing"
                          (change)="updateGenerateStudentRegistrationId(GenerateStudentRegistrationId)"
                          [(ngModel)]="GenerateStudentRegistrationId" class="termType ng-valid ng-dirty ng-touched"
                          name="includeinterm" type="checkbox">
                        <span *ngIf="GenerateStudentRegistrationId"
                          style="font-size: small;color: #2B323A;">{{ 'nowAutoGenerate' | translate }} <i
                            *ngIf="isProcessing" class="fa fa-spinner fa-spin"></i></span>
                        <span *ngIf="!GenerateStudentRegistrationId"
                          style="font-size: small;color: #2B323A">{{ 'nowManualUpdate' | translate }} <i
                            *ngIf="isProcessing" class="fa fa-spinner fa-spin"></i></span>
                      </label>
                    </div>
                  </div>
                  <div id = "TimezoneHeading"class="col-md-6" >
                   {{ 'pleaseSelectAnyTimeZone' | translate }}
                  </div>
                  <div id = "dropdownList" class="col-md-5" >
                    <div>
                      <select 
                      (change)="getSelectedTimeZone($event.target.value)"
                      [(ngModel)]="selectedTimezone">
                      <option *ngFor="let timezones of getTimeZoneArray" value="{{timezones.pkSupportedTimeZoneId}}" >
                        {{timezones.region}}</option>
                    </select>
                    </div>
                  </div>
                   <div class="col-md-1" style="padding: 0;font-size: 15px;padding-bottom: 10px;margin-left: -105px;"> 
                    <div>
                    <button id= "saveButton" type="button" (click)="setSchoolTimeZone()" [disabled]="!selectedTimeZoneId"> {{ 'save' | translate }} </button>
                   </div> 
                   </div>
                  <div class="col-md-6" style="padding-bottom: 15px; padding-top: 10px; padding-left: 0px;">
                    {{ 'markAttendanceAfterCheckIn' | translate }}
                  </div>
                  <div class="col-md-6" style="padding: 0;font-size: 15px;padding-bottom: 10px;margin-left: -105px;">
                    <div class="checkbox checkbox-styled">
                      <label>
                        <input [disabled]="isMarkAttedanceAfterCheckInUpdating" (change)="updateMarkAttendanceAfterCheckIn(markAttendanceAfterCheckin)"
                          [(ngModel)]="markAttendanceAfterCheckin" class="termType ng-valid ng-dirty ng-touched" name="includeinterm"
                          type="checkbox">
                        <span style="font-size: small;color: #2B323A;">
                          <i *ngIf="isMarkAttedanceAfterCheckInUpdating" class="fa fa-spinner fa-spin"></i>
                        </span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div> 

            <!--MANAGE BOARD TAB START HERE-->
            <div class="tab-pane" id="manageBoard">
              <div class="row col-md-12">
                <div class="col-md-8 col-md-offset-2 text-center"
                  style="color: #6b6b6b;font-weight: 300;margin-top: 1em;z-index: 999">
                  <h4><span id="sequence-class" (click)="fetchClassStandardAndSection()"
                      style="cursor: pointer"><u>{{ 'clickHere' | translate }}</u></span> {{ 'toCreateEducationalBoard' | translate }}</h4>
                </div>
                <div class="row">
                  <div class="col-md-12 table-responsive" style="padding: 0em 2em;margin-top: -3em">
                    <table id="examBoardTable" class="table table-striped ">
                      <thead>
                        <tr>
                          <th>{{ 'boardName' | translate }}</th>
                          <th>{{ 'evaluationType' | translate }}</th>
                          <th>{{ 'totalClass' | translate }}</th>
                          <th>{{ 'totalSection' | translate }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let board of examBoardList" (click)="getClassListByExamBoard(board)"
                          data-toggle="modal" data-target="#" style="cursor: pointer;">
                          <td>{{board.BoardName}}</td>
                          <td>{{board.EvaluationType}}</td>
                          <td>{{board.TotalClassStandard}}</td>
                          <td>{{board.TotalSection}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <!--MANAGE BOARD TAB END HERE-->

            <!-- Subscriptions -->
            <!-- <div class="tab-pane" id="subscription">
               <div class="col-md-5">
                 <div class="card col-md-12">
                   <div class="row" style="margin: 10px 10px;">
                     <p class="pull-left"><img src="http://www.gs1.org/sites/default/files/barcode-1.jpg" class="img-responsive" style="width: 75px;"></p>
                     <p class="pull-right" style="margin-top: 1em;">
                       <img src="images_ext/logo1.png" class="img-responsive" style="  width: 40px;display: inline-block;">
                       <span class="text-lg text-bold text-primary">{{ brand.name | uppercase }}</span>
                     </p>
                   </div>
                   <div class="row" style="margin-bottom: 10px;background: var(--select-bg-color);color: white;text-align: center;">
                     <h3 style="margin: 0;padding: 10px 0px;font-weight: 100;    letter-spacing: 5px;">Premium Account</h3>
                   </div>
                   <div class="row text-center">
                     <h5 style="margin: 0;color: #6d6d6d;letter-spacing: 1px;    text-transform: lowercase; font-weight: 400; margin-bottom: 10px;">CAPRICORN INTERNATIONAL SCHOOL</h5>
                   </div>
                   <div class="row" style="margin: 0px 0px;color: #6f6f6f;">
                     <h6 class="pull-left">Expire</h6>
                     <h6 class="pull-right">07/2017</h6>
                   </div>
                 </div>
               </div>

               <div class="card col-md-7" style="padding: 0;">
                 <div class="col-md-12" style="padding: 0;">
                   <div class="row" style="margin: 0px 20px;">
                     <h5 class="pull-left" style="letter-spacing: 2px;color: #bdbdbd;font-weight: 400;font-size: 1.3em;margin-top: 18px;"><i class="fa fa-th"></i></h5>
                     <h2 class="pull-right" style="-ms-transform: rotate(45deg); /* IE 9 */-webkit-transform: rotate(45deg); /* Chrome, Safari, Opera */transform: rotate(45deg);color: var(--select-bg-color);margin: 0;font-size: 3em;"><i class="fa fa-caret-up"></i></h2>
                   </div>
                   <h4 class="text-center" style="letter-spacing: 2px;color: #4e4e4e;border-bottom: 1px solid #e2e2e2;padding-bottom: 15px;">SUBSCRIPTION HISTORY</h4>

                   <div class="row" style="margin: 0;">
                     <ul style="list-style: none;padding: 0;max-height: 300px;overflow: auto;min-height: 300px;" id="sub-history">
                       <li style="border-bottom: 1px solid #e2e2e2;padding: 0px 40px;">
                         <div class="row" style="margin: 0;">
                           <p style="font-weight: 400;color: #565656;" class="pull-left">Account Created</p>
                           <p style="font-weight: 400;color: #565656;" class="pull-right">20/MARCH/2016</p>
                         </div>
                       </li>
                       <li style="border-bottom: 1px solid #e2e2e2;padding: 0px 40px;">
                         <div class="row" style="margin: 0;">
                           <p style="font-weight: 400;color: #565656;" class="pull-left">Account Created</p>
                           <p style="font-weight: 400;color: #565656;" class="pull-right">20/MARCH/2016</p>
                         </div>
                       </li>
                       <li style="border-bottom: 1px solid #e2e2e2;padding: 0px 40px;">
                         <div class="row" style="margin: 0;">
                           <p style="font-weight: 400;color: #565656;" class="pull-left">Account Created</p>
                           <p style="font-weight: 400;color: #565656;" class="pull-right">20/MARCH/2016</p>
                         </div>
                       </li>
                       <li style="border-bottom: 1px solid #e2e2e2;padding: 0px 40px;">
                         <div class="row" style="margin: 0;">
                           <p style="font-weight: 400;color: #565656;" class="pull-left">Account Created</p>
                           <p style="font-weight: 400;color: #565656;" class="pull-right">20/MARCH/2016</p>
                         </div>
                       </li>
                       <li style="border-bottom: 1px solid #e2e2e2;padding: 0px 40px;">
                         <div class="row" style="margin: 0;">
                           <p style="font-weight: 400;color: #565656;" class="pull-left">Account Created</p>
                           <p style="font-weight: 400;color: #565656;" class="pull-right">20/MARCH/2016</p>
                         </div>
                       </li>
                       <li style="border-bottom: 1px solid #e2e2e2;padding: 0px 40px;">
                         <div class="row" style="margin: 0;">
                           <p style="font-weight: 400;color: #565656;" class="pull-left">Account Created</p>
                           <p style="font-weight: 400;color: #565656;" class="pull-right">20/MARCH/2016</p>
                         </div>
                       </li>
                       <li style="border-bottom: 1px solid #e2e2e2;padding: 0px 40px;">
                         <div class="row" style="margin: 0;">
                           <p style="font-weight: 400;color: #565656;" class="pull-left">Account Created</p>
                           <p style="font-weight: 400;color: #565656;" class="pull-right">20/MARCH/2016</p>
                         </div>
                       </li>
                       <li style="border-bottom: 1px solid #e2e2e2;padding: 0px 40px;">
                         <div class="row" style="margin: 0;">
                           <p style="font-weight: 400;color: #565656;" class="pull-left">Account Created</p>
                           <p style="font-weight: 400;color: #565656;" class="pull-right">20/MARCH/2016</p>
                         </div>
                       </li>
                       <li style="border-bottom: 1px solid #e2e2e2;padding: 0px 40px;">
                         <div class="row" style="margin: 0;">
                           <p style="font-weight: 400;color: #565656;" class="pull-left">Account Created</p>
                           <p style="font-weight: 400;color: #565656;" class="pull-right">20/MARCH/2016</p>
                         </div>
                       </li>
                       <li style="border-bottom: 1px solid #e2e2e2;padding: 0px 40px;">
                         <div class="row" style="margin: 0;">
                           <p style="font-weight: 400;color: #565656;" class="pull-left">Account Created</p>
                           <p style="font-weight: 400;color: #565656;" class="pull-right">20/MARCH/2016</p>
                         </div>
                       </li>
                     </ul>
                   </div>
                 </div>
               </div>
             </div>-->
          </div>
          <!--end .card-body -->
        </div>
        <!--end .card -->

      </section>
    </div>
    <!--end #content-->
    <!-- END CONTENT -->

    <!-- Menubar -->
    <!--  -->

    <!-- Edit Profile -->
    <!-- BEGIN SIMPLE MODAL MARKUP -->
    <div class="modal fade" id="simpleModal" tabindex="-1" role="dialog" aria-labelledby="simpleModalLabel"
      aria-hidden="true">
      <div class="modal-dialog" style="width: 75%;">
        <div class="modal-content">
          <div class="modal-header hidden" style="padding-bottom: 5px;">


          </div>
          <div class="modal-body">

            <div class="row card"
              style="margin: 0;border-bottom: 1px solid #ececec;padding-bottom: 1em;    color: #676767;">
              <h1 style="color: #F44336;display: inline-block;cursor:pointer;margin: 0;" data-dismiss="modal"
                aria-hidden="true"><i class="md md-keyboard-arrow-left"></i></h1>
              <h2 class="text-center" style="margin-top: -1.1em;margin-bottom: 0;">{{ 'editProfile' | translate }}</h2>
            </div>

            <div class="row card" style="margin: 0;padding: 25px 25px;">
              <h4>{{ 'profileInfo' | translate }}</h4>

              <form class="form">
                <div class="row" style="margin:0;">
                  <!--<div class="col-md-3">
                    <div class="cropme" style="width: 150px;height: 150px;float: none;margin: 0 auto;"></div>
                  </div>-->
                  <div class="form-group col-md-12">
                    <input type="text" class="form-control" id="placeholder"
                      placeholder="CAPRICORN INTERNATIONAL SCHOOL" style="margin-left: -0.7em;">
                    <label for="placeholder">{{ 'schoolName' | translate }}</label>
                  </div>
                  <div class="form-group col-md-9">
                    <textarea style="margin-left: -10px;font-size: 14px;" name="textarea2" id="textarea2"
                      class="form-control" rows="3"
                      placeholder="Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."></textarea>
                    <label for="textarea2">{{ 'aboutYourSchool' | translate }}</label>
                  </div>
                </div>
                <div class="row" style="margin:0;margin-top: 25px;">
                  <div class="form-group col-md-6">
                    <input type="text" class="form-control" id="placeholdermail" placeholder="info@capricon.com"
                      style="margin-left: -0.7em;">
                    <label for="placeholdermail">{{ 'email' | translate }}</label>
                  </div>

                  <div class="form-group col-md-6">
                    <input type="text" class="form-control" id="placeholdernum" placeholder="+91 9087890767"
                      style="margin-left: -0.7em;" maxlength="10">
                    <label for="placeholdernum">{{ 'contactNumber' | translate }}</label>
                  </div>
                  <div class="form-group col-md-4">
                    <input type="text" class="form-control" id="placeholdercity" placeholder="Cochin"
                      style="margin-left: -0.7em;">
                    <label for="placeholdercity">{{ 'city' | translate }}</label>
                  </div>
                  <div class="form-group col-md-4">
                    <input type="text" class="form-control" id="placeholderstate" placeholder="Kerala"
                      style="margin-left: -0.7em;">
                    <label for="placeholderstate">{{ 'state' | translate }}</label>
                  </div>
                  <div class="form-group col-md-4">
                    <input type="text" class="form-control" id="placeholderpincode" placeholder="688106"
                      style="margin-left: -0.7em;">
                    <label for="placeholderpincode">{{ 'pincode' | translate }}</label>
                  </div>
                  <div class="form-group col-md-12">
                    <input type="text" class="form-control" id="placeholderadd" placeholder="15B 9th cross"
                      style="margin-left: -0.7em;">
                    <label for="placeholderadd">{{ 'streetAddress' | translate }}</label>
                  </div>
                </div>
              </form>

              <h4>{{ 'chatLimit' | translate }} </h4>
              <form class="form-horizontal">
                <div class="form-group col-md-6">
                  <label class="col-sm-12">{{ 'staffChatLimit' | translate }}"</label>
                  <div class="col-sm-12">
                    <label class="radio-inline radio-styled">
                      <input type="radio" name="inlineRadioOptions" value="option1"><span>{{ 'limited' | translate }}</span>
                    </label>
                    <label class="radio-inline radio-styled">
                      <input type="radio" name="inlineRadioOptions" value="option2"><span>{{ 'unlimited' | translate }}</span>
                    </label>
                  </div>
                  <!--end .col -->
                  <div class="form-group">
                    <div class="col-sm-3">
                      <label for="select1" style="margin-top: 20px;float: right;color: #888888;">{{ 'selectLimit' | translate }}</label>
                    </div>
                    <div class="col-sm-6">
                      <select id="select" name="select1" class="form-control">
                        <option value="">&nbsp;</option>
                        <option value="30">10</option>
                        <option value="40">20</option>
                        <option value="50">30</option>
                        <option value="60">40</option>
                        <option value="70">50</option>
                        <option value="30">60</option>
                        <option value="40">70</option>
                        <option value="50">80</option>
                        <option value="60">90</option>
                        <option value="70">100</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="form-group col-md-6">
                  <label class="col-sm-12">{{ 'studentChatLimit' | translate }}</label>
                  <div class="col-sm-12">
                    <label class="radio-inline radio-styled">
                      <input type="radio" name="inlineRadioOptions" value="option1"><span>{{ 'limited' | translate }}</span>
                    </label>
                    <label class="radio-inline radio-styled">
                      <input type="radio" name="inlineRadioOptions" value="option2"><span>{{ 'unlimited' | translate }}</span>
                    </label>
                  </div>
                  <!--end .col -->

                  <div class="form-group">
                    <div class="col-sm-3">
                      <label for="select1" style="margin-top: 20px;float: right;color: #888888;">{{ 'selectLimit' | translate }}</label>
                    </div>
                    <div class="col-sm-6">
                      <select id="select1" name="select1" class="form-control">
                        <option value="">&nbsp;</option>
                        <option value="30">10</option>
                        <option value="40">20</option>
                        <option value="50">30</option>
                        <option value="60">40</option>
                        <option value="70">50</option>
                        <option value="30">60</option>
                        <option value="40">70</option>
                        <option value="50">80</option>
                        <option value="60">90</option>
                        <option value="70">100</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="btn-group pull-right">
                  <button style="margin: 0px 5px;" type="button" class="btn ink-reaction btn-info"><i
                      class="fa fa-send"></i> {{ 'update' | translate }}</button>
                  <button data-dismiss="modal" aria-hidden="true" style="margin: 0px 5px;" type="button"
                    class="btn ink-reaction btn-danger"><i class="fa fa-stop"></i> {{ 'cancel' | translate }}</button>
                </div>

              </form>

            </div>

          </div>
          <div class="modal-footer hidden">
            <!-- <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>
  <button type="button" class="btn btn-primary">Save changes</button> -->
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->
    <!-- END SIMPLE MODAL MARKUP -->

    <!-- Deactivate Account -->
    <div id="deactivateModal" class="modal fade" role="dialog">
      <div class="modal-dialog" style="margin-top:121px">

        <!-- Modal content-->
        <div class="modal-content">
          <!-- <div class="modal-body"> -->
          <div class="col-md-12">
            <div class="col-md-6 col-sm-6 col-xs-6" style="background-color: var(--secondary-btn-bg-color);width:280px;height:280px">
              <i class="fa fa-user-times fa-5x" aria-hidden="true" style="color:white;padding:83px 0px 0px 89px">
                <h3 style="margin-left: -40px;font-family: sans-serif;">{{ 'deactivateAccount' | translate }}</h3>
              </i>
            </div>
            <div class="col-md-6 col-sm-6 col-xs-6" style="background-color: white;width:280px;height:280px">
              <button type="button" class="  btn ink-reaction btn-floating-action btn-primary" data-dismiss="modal"
                style="background: var(--secondary-btn-bg-color);float: right;margin-top: -1em;margin-right: -2em;border: none">&times;</button>

              <div class="form-group floating-label" style="padding-top:113px;text-align: center;margin-left:27px">
                <div class="input-group">

                  <div class="input-group-content">
                    <input type="text" class="form-control" id="username10">
                    <label for="username10" style="margin-top: -15px;font-size: 15px">{{ 'enterTheMobileNumber' | translate }}</label>
                  </div>
                </div>
              </div>
              <button class="btn btn-info btn-md btnclass col-sm-offset-3">{{ 'deactivate' | translate }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ////// -->

    <!-- Reactivate Modal -->
    <div id="reactivateModal" class="modal fade" role="dialog">
      <div class="modal-dialog" style="margin-top:121px">

        <!-- Modal content-->
        <div class="modal-content">

          <div class="row">
            <div class="col-md-6 col-sm-6 col-xs-6 text-center"
              style="background-color: var(--secondary-btn-bg-color);height: 300px;color: white;padding: 50px 0px;">
              <h1 style="   font-size: 5em;"><i class="fa fa-check-square-o"></i></h1>
              <h3 style="  font-weight: 100;">{{ 'reactivateAccount' | translate }}</h3>
            </div>
            <div class="col-md-6 col-sm-6 col-xs-6" style="background-color: white;height: 300px;">
              <button type="button" id="reactivatepopupclose"
                class="reactivatepopupclose  btn ink-reaction btn-floating-action btn-primary" data-dismiss="modal"
                style="background: var(--secondary-btn-bg-color);float: right;margin-top: -1em;margin-right: -2em;border: none">×</button>

              <ul style="padding: 28px 48px;line-height: 35px;font-size: 14px;margin-left:-15px">
                <li class="reactborder" style="display:inline-block;">
                  <span style="    color: rgba(128, 128, 128, 0.62);margin-left: 20px;">{{ 'accountType' | translate }}&nbsp;</span>
                  <span style="color:grey">{{reactivatestudetails.accountType}}</span>
                </li>
                <li class="reactborder" style="display:inherit;">
                  <span style="    color: rgba(128, 128, 128, 0.62);margin-left: 20px;">{{ 'name' | translate }}&nbsp;</span>
                  <span style="color:grey">{{reactivatestudetails.parentName}}</span>
                </li>
                <li class="reactborder" style="display:inherit;">
                  <span style="    color: rgba(128, 128, 128, 0.62);margin-left: 20px;">{{ 'mobiileNo' | translate }}&nbsp;</span>
                  <span style="color:grey">{{reactivatestudetails.mobileNumber}}</span>
                </li>
                <li class="reactborder" style="display:inherit;">
                  <span style="    color: rgba(128, 128, 128, 0.62);margin-left: 20px;">{{ 'email-id' | translate }}&nbsp;</span>
                  <span style="color:grey">{{reactivatestudetails.emailId ? reactivatestudetails.emailId : "-" }}</span>
                </li>
                <li class="reactborder" style="display:inherit;">
                  <span style="    color: rgba(128, 128, 128, 0.62);margin-left: 20px;">{{ 'reason' | translate }}&nbsp;</span>
                  <span style="color:grey">{{reactivatestudetails.reason ? reactivatestudetails.reason: "-"}}</span>
                </li>

              </ul>
              <button id="reactive" class="btn btn-info btn-md btnclass col-sm-offset-3" (click)="reactivatestudent()"
                style="margin-top: -30px">{{ 'reactivate' | translate }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>


    <!--start change password modal-->
    <div id="ChangePasswordModal" class="modal fade" role="dialog">
      <div class="modal-dialog" style="margin-top:35px">
        <!-- Modal content-->
        <div class="modal-content">

          <div class="row">
            <div class="col-sm-2 hidden-xs"
              style="background-color: var(--secondary-btn-bg-color);height: 293px;color: white;padding: 50px 0px;">

            </div>
            <div class="col-sm-10" style="background-color: #ffffff;height: 293px;padding: 50px 15px;">
              <button type="button" id="changeuserpsswdpopupclose"
                class="  btn ink-reaction btn-floating-action btn-primary" data-dismiss="modal"
                style="background: var(--secondary-btn-bg-color);float: right;margin-top: -4em;margin-right: -2em;border: none;">×</button>

              <div class="col-md-12" style="margin-bottom: 2em;">
                <h3 style="margin: 0;font-weight: 100;color: #909090;"><i style="color:var(--secondary-btn-bg-color);"
                    class="fa fa-user-plus"></i> {{ 'changePassword' | translate }}</h3>
              </div>

              <form class="form">
                <div class="form-group col-md-6">
                  <input type="password" class="form-control" [(ngModel)]="userPassword" name="password" id="placehold"
                    [placeholder]="'enterPassword' | translate" style="margin-left: -0.7em;font-size: small;">
                  <label for="placeholder2">{{ 'password' | translate }}</label>
                </div>
                <div class="form-group col-md-6">
                  <input type="password" class="form-control" [(ngModel)]="usercnfmpassword" name="confirmpassword"
                    id="placehol" [placeholder]="'confirmYourPassword' | translate" style="margin-left: -0.7em;font-size: small;">
                  <label for="placeholder7">{{ 'confirmPassword' | translate }}</label>
                </div>
              </form>
              <div class="btn-group text-center col-md-12">
                <button type="button" id="changepswd" (click)="updatePasswordForUser()"
                  class="pull-right btn ink-reaction"
                  style="border: 1px solid;margin: 0px 5px;background: white;color: var(--secondary-btn-bg-color);">{{ 'updatePassword' | translate }}</button>
                <button type="button" id="passwordpopupclose" class="pull-right btn ink-reaction"
                  style="    border: 1px solid;margin: 0px 5px;background: white;color: var(--secondary-btn-bg-color);"
                  data-dismiss="modal">{{ 'cancel' | translate }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--end change password modal-->
    <!-- ////// -->
    <!--start deleteuser-->
    <div id="deleteusermodal" class="modal fade" role="dialog">
      <div class="modal-dialog">
        <div class="modal-content" style="margin-top: 190px">
          <div class="modal-body">
            <h3 style="margin: 0;font-weight: 100;color: #909090;"><i class="fa fa-user-times"
                style="color:var(--secondary-btn-bg-color);"></i> {{ 'deleteUser' | translate }}</h3>
            <button class="  btn ink-reaction btn-floating-action btn-primary" data-dismiss="modal"
              style="background: var(--secondary-btn-bg-color);float: right;margin-top: -3em;margin-right: -2em;border: none;"
              type="button">×</button>
            <p style="    font-size: 19px;
    margin-left: 6pc;
    padding: 29px 30px;">{{ 'areYouConfirmToDeleteUser' | translate }}</p>
            <div style="padding:0px 205px;    margin-top: -12px;">
              <button (click)="deleteAdminUser()" class="btn btn-info btn-sm" style="width: 67px;">{{ 'ok' | translate }}</button>
              <button id="deletepopupclose" class="btn btn-info btn-sm" data-dismiss="modal">{{ 'cancel' | translate }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--end delete user-->
    <!--Activate admin user-->

    <div id="activateAdmin" class="modal fade" role="dialog">
      <div class="modal-dialog">
        <div class="modal-content" style="margin-top: 190px">
          <div class="modal-body">
            <h3 style="margin: 0;font-weight: 100;color: #909090;"><i class="fa fa-user-times"
                style="color:var(--secondary-btn-bg-color);"></i>{{ 'activateUserAdmin' | translate }}</h3>
            <button class="  btn ink-reaction btn-floating-action btn-primary" data-dismiss="modal"
              style="background: var(--secondary-btn-bg-color);float: right;margin-top: -3em;margin-right: -2em;border: none;"
              type="button">×</button>
            <p style="    font-size: 19px;
    margin-left: 6pc;
    padding: 29px 30px;">{{ 'areYouConfirmToActivateTheUser' | translate }}</p>
            <div style="padding:0px 205px;    margin-top: -12px;">
              <button (click)="activateAdminUser()" class="btn btn-info btn-sm" style="width: 67px;">{{ 'ok' | translate }}</button>
              <button id="activeAdminColse" class="btn btn-info btn-sm" data-dismiss="modal">{{ 'cancel' | translate }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Add User Modal -->
    <div id="addUserModal" class="modal fade" role="dialog">
      <div class="modal-dialog" style="margin-top:35px">
        <!-- Modal content-->
        <div class="modal-content">

          <div class="row">
            <div class="col-sm-2 hidden-xs"
              style="background-color: var(--secondary-btn-bg-color);height: 550px;color: white;padding: 50px 0px;">

            </div>
            <div class="col-sm-10" style="background-color: #ffffff;height: 550px;padding: 50px 15px;">
              <button type="button" id="adduserpopupclose" class="  btn ink-reaction btn-floating-action btn-primary"
                data-dismiss="modal"
                style="background: var(--secondary-btn-bg-color);float: right;margin-top: -4em;margin-right: -2em;border: none;">×</button>

              <div class="col-md-12" style="margin-bottom: 2em;">
                <h3 style="margin: 0;font-weight: 100;color: #909090;"><i style="color:var(--secondary-btn-bg-color);"
                    class="fa fa-user-plus"></i> {{ 'addUser' | translate }}</h3>
              </div>

              <form class="form">
                <!--<div class="col-md-4" style="padding-top: 2em;">
                  <div class="cropme" style="width: 75px;height: 75px;float: none;margin: 0 auto;background-size: contain;background-color: white;"></div>
                </div>-->
                <div class="form-group col-md-6">
                  <input type="text" class="form-control" [(ngModel)]="adduser.username" name="username"
                    id="placeholder8" [placeholder]="'enterUsername' | translate" style="margin-left: -0.7em;font-size: small;">
                  <label for="placeholder8">{{ 'userName' | translate }}</label>
                </div>
                <div class="form-group col-md-6">
                  <input type="text" class="form-control " [(ngModel)]="adduser.emailId " name="emailId"
                    id="placeholder5" [placeholder]="'enterEmailId' | translate" style="margin-left: -0.7em;font-size: small;">
                  <label for="placeholder5">{{ 'emailid' | translate }}</label>
                </div>
                <div class="form-group col-md-6">
                  <input type="password" class="form-control" [(ngModel)]="adduser.password " name="password"
                    id="placeholder2" [placeholder]="'enterPassword' | translate" style="margin-left: -0.7em;font-size: small;">
                  <label for="placeholder2">{{ 'password' | translate }}</label>
                </div>
                <!--<div class="row" style="margin: 0px 0px 0px 10px;">-->
                <div class="form-group col-md-6">
                  <input type="password" class="form-control" [(ngModel)]="adduser.cnfmpassword " name="confirmpassword"
                    id="placeholder7" [placeholder]="'confirmYourPassword' | translate" style="margin-left: -0.7em;font-size: small;">
                  <label for="placeholder7">{{ 'confirmPassword' | translate }}</label>
                </div>
                <div class="form-group col-md-6">
                  <input type="number" class="form-control " [(ngModel)]="adduser.PhoneNumber " name="PhoneNumber"
                    id="adduserphnum" style="margin-left: -0.7em;font-size: small;">
                  <label for="adduserphnum">{{ 'mobileNumber' | translate }}</label>
                </div>
                <div class="form-group col-md-6">
                  <label for="adminType" style="color: #888888;">{{ 'accessType' | translate }}</label>
                  <select [(ngModel)]="adduser.AccessType" (change)="showHideAddUser($event.target.value)"
                    id="adminType" name="select1" class="form-control" style="margin-left: -0.7em;">
                    <option value="SUPER_ADMIN" id="adminsuper">{{ 'superAdmin' | translate }}</option>
                    <option value="SUB_ADMIN" id="subadmin">{{ 'subAdmin' | translate }}</option>
                  </select>
                </div>
                <!-- </div>-->
              </form>
              <div *ngIf="featurelist" class="col-md-12">
                <h4 id="featuretitle"
                  style="display: inline-block;font-weight: bolder;color: #6b6d64;font-size: large;">{{ 'selectFeaturesForThisUser' | translate }}</h4>
                <form class="form" style="max-height: 10em;overflow: auto;" id="userFeatures">
                  <!--<div id="featurelistforuser" class="checkbox checkbox-styled"  style="display: inline-block;margin: 0px 5px;">-->
                  <label *ngFor="let usrflist of getuserfeaturelist"
                    class="checkbox-inline checkbox-styled checkbox-primary col-md-12" style="margin: 0px;">
                    <input type="checkbox" [(ngModel)]="usrflist.select" name="selectfeature" class="featureList">
                    <span>{{usrflist.BluewingsFeatureDescription}}</span>
                  </label>
                  <!--</div>-->
                </form>
              </div>

              <div class="btn-group text-center col-md-12">
                <button type="button" (click)="addUserDetails()" class="pull-right btn ink-reaction"
                  id="adduserbuttondsble"
                  style="border: 1px solid;margin: 0px 5px;background: white;color: var(--secondary-btn-bg-color);">{{ 'addUser' | translate }}</button>
                <button type="button" id="adduser" class="pull-right btn ink-reaction"
                  style="    border: 1px solid;margin: 0px 5px;background: white;color: var(--secondary-btn-bg-color);"
                  data-dismiss="modal">{{ 'cancel' | translate }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ///// -->
    <!--edit user-->
    <div id="editUserModal" class="modal fade" role="dialog" aria-hidden="true">
      <div class="modal-dialog" style="margin-top:35px">
        <!-- Modal content-->
        <div class="modal-content">

          <div class="row">
            <div class="col-sm-2 hidden-xs"
              style="background-color: var(--secondary-btn-bg-color);height: 550px;color: white;padding: 50px 0px;">

            </div>
            <div class="col-sm-10" style="background-color: #ffffff;height: 550px;padding: 50px 15px;">
              <button type="button" class="  btn ink-reaction btn-floating-action btn-primary" data-dismiss="modal"
                style="background: var(--secondary-btn-bg-color);float: right;margin-top: -4em;margin-right: -2em;border: none;">×</button>

              <div class="col-md-12" style="margin-bottom: 2em;">
                <h3 style="margin: 0;font-weight: 100;color: #909090;"><i style="color:var(--secondary-btn-bg-color);"
                    class="fa fa-user-plus"></i>{{ 'updateUser' | translate }}</h3>
              </div>

              <form class="form">
                <div class="form-group col-md-4">
                  <input type="text" class="form-control" [(ngModel)]="getuserdetails.emailId " name="mailid"
                    id="emailid" [placeholder]="'enterEmailId' | translate" style="margin-left: -0.7em;font-size: small;">
                  <label for="emailid">{{ 'emailid' | translate }}</label>
                </div>
                <div class="form-group col-md-4">
                  <input type="number" class="form-control" [(ngModel)]="getuserdetails.adminPhoneNumber "
                    name="PhoneNumber" [placeholder]="'enterNumber' | translate" id="mobnum"
                    style="margin-left: -0.7em;font-size: small;">
                  <label for="mobnum">{{ 'mobileNumber' | translate }}</label>
                </div>
                <div class="form-group col-md-4">
                  <label for="adminType" id="typelist" style="color: #888888;">{{ 'accessType' | translate }}</label>
                  <select id="editadmintype" [(ngModel)]="getuserdetails.AccessType"
                    (change)="showHide($event.target.value)" name="select1" class="form-control">
                    <option value="SUPER_ADMIN" id="superid">{{ 'superAdmin' | translate }}</option>
                    <option value="SUB_ADMIN" id="suberid">{{ 'subAdmin' | translate }}</option>
                  </select>
                </div>
              </form>
              <div *ngIf="featurelist" class="col-md-12">
                <h4 id="ftretit" style="display: inline-block;padding: 5px 10px;">{{ 'selectFeaturesForThisUser' | translate }}</h4>
                <form class="form" style="overflow: auto;max-height: 20em;" id="edituserFeatures">

                </form>
              </div>

              <div class="btn-group text-center col-md-12">
                <button type="button" (click)="updateAdminUser()" id="edituser" class="pull-right btn ink-reaction"
                  style="    border: 1px solid;margin: 0px 5px;background: white;color: var(--secondary-btn-bg-color);">{{ 'updateUser' | translate }}</button>
                <button type="button" id="edituserpopupclose" class="pull-right btn ink-reaction"
                  style="    border: 1px solid;margin: 0px 5px;background: white;color: var(--secondary-btn-bg-color);"
                  data-dismiss="modal">{{ 'cancel' | translate }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--end of edit user-->

    <!--CLASS SECTION MODEL START-->
    <div class="modal fade" id="classSection" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog" style="padding: 10em 0em;">
        <div class="modal-content" style="padding: 5em 1em;border: 5px dashed;">
          <div class="col-md-12 text-center">
            <h4 style="color: blue;margin-top: -3em;">{{ 'classSectionList' | translate }}</h4>
          </div>
          <div class="row">
            <div class="col-md-4" style="margin-top: -4px;">
              <h4>{{ 'classSectionList' | translate }} </h4>
            </div>
            <div class="col-md-8 checkbox checkbox-styled" style="display: inline-block;">
              <label>
                <input type="checkbox" [(ngModel)]="allSection" id="selectAllSection" (change)="selectAllSection()"
                  name="selectAllSection">
                <span>{{ 'selectAll' | translate }}</span>
              </label>
            </div>
            <div class="col-md-12" id="classSecList"
              style="padding: 5px 5px;border: 1px solid gainsboro;overflow: auto">
              <div class="checkbox checkbox-styled col-md-3" *ngFor="let cl of sectionListOfClass"
                style="display: inline-block;margin: 0px;">
                <label>
                  <input type="checkbox" [(ngModel)]="cl.select" (change)="checkingSelectSection(sectionListOfClass)"
                    name="{{'section'+cl.classId}}">
                  <span>{{cl.ClassStandard}} {{cl.classDivision}}</span>
                </label>
              </div>
            </div>
            <div class="col-md-12 text-center" style="position: fixed;bottom: 12em;">
              <button type="button" class="btn btn-raised ink-reaction btn-info" (click)="classStdSectionList()"
                style="padding: 3px 20px;">{{ 'add' | translate }}</button>
              <button type="button" id="closeSectionPopup" class="btn btn-raised ink-reaction btn-info"
                style="padding: 3px 20px;" data-dismiss="modal" aria-hidden="true">{{ 'close' | translate }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--CLASS SECTION MODEL END-->

    <!-- BEGIN CREATE EXAM BOARD  -->
    <div class="modal fade" id="gradingSysmtemConfig" tabindex="-1" role="dialog" aria-labelledby="simpleModalLabel"
      aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body" style="padding: 12px;padding-top: 0px;">
            <div class="row">
              <div class="col-md-12 text-center" style="background: var(--tertiary-btn-bg-color);">
                <div style="margin-bottom: 10px;">
                  <h2 class="lead"
                    style="display: inline-block;line-height: 15px;margin: 0;font-weight: 100;color: white;margin-top: 15px;">
                     {{ 'gradingSystemConfiguration' | translate }}<br><span style="font-size: 12px;font-weight: 100;">{{ 'addNewExamGradingSystem' | translate }}
                      </span></h2>
                  <h3 id="closeResultConfigPopup" data-dismiss="modal"
                    style="display: inline-block;float: right;margin-right: 10px;margin-top: 15px;color: white;cursor: pointer;">
                    x</h3>
                </div>
              </div>
              <div class="col-md-12" style="padding: 2em 0;">
                <div class="col-md-12 table-responsive">
                  <table id="configResultTable" class="table table-striped" style="border: 1px solid gainsboro">
                    <thead>
                      <tr>
                        <th class="col-md-2 text-center" style="border: 1px solid gainsboro">{{ 'minMarks' | translate }}</th>
                        <th class="col-md-2 text-center" style="border: 1px solid gainsboro">{{ 'maxMarks' | translate }}</th>
                        <th class="col-md-2 text-center" style="border: 1px solid gainsboro">{{ 'grade' | translate }}</th>
                        <th class="col-md-3 text-center" style="border: 1px solid gainsboro">{{ 'gradePoint' | translate }}</th>
                        <th class="col-md-3 text-center" style="border: 1px solid gainsboro">{{ 'manageRow' | translate }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr id="examResultTableRow" *ngFor="let obj of configGrade;let i = index">
                        <td class="col-md-2 text-center" style="border: 1px solid gainsboro;"><input type="text"
                            class="examResultData" [(ngModel)]="obj.minMarks" name="minMarks" style="width: 7em;"
                            maxlength="3"></td>
                        <td class="col-md-2 text-center" style="border: 1px solid gainsboro;"><input type="text"
                            class="examResultData" [(ngModel)]="obj.maxMarks" name="maxMarks" style="width: 7em;"
                            maxlength="3"></td>
                        <td class="col-md-2 text-center" style="border: 1px solid gainsboro;"><input type="text"
                            class="examResultData" [(ngModel)]="obj.grade" name="grade" style="width: 7em;"
                            maxlength="2"></td>
                        <td class="col-md-3 text-center" style="border: 1px solid gainsboro;"><input type="text"
                            class="examResultData" [(ngModel)]="obj.gradePoint" name="gradePoint" style="width: 7em;"
                            maxlength="5"></td>
                        <td class="col-md-3" style="border: 1px solid gainsboro">
                          <span><button (click)="addRowInConfigResult(obj)" *ngIf="(i+1)== configGrade.length"
                              type="button" class="btn ink-reaction btn-floating-action btn-primary"
                              style="background: #E91E63;border: none;width: 40px;height: 40px;position:fixed;bottom:0;margin: 6.7em 0em;"><i
                                class="fa fa-plus"></i></button></span>
                          <span style="margin-left: 4em;" [style.display]="i==0 ? 'none':''"><button
                              (click)="removeRowConfigResult()" *ngIf="(i+1)== configGrade.length" type="button"
                              class="btn ink-reaction btn-floating-action btn-primary"
                              style="background: #E91E63;border: none;width: 40px;height: 40px;position:fixed;bottom:0;margin: 6.7em 0em;"><i
                                class="fa fa-minus"></i></button></span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="col-md-12 text-center" style="padding-top: 10px;">
                  <button id="configGradeButton" type="button" class="btn btn-raised ink-reaction btn-info"
                    (click)="gradeSystemConfig()">{{ 'configure' | translate }}</button>
                  <button id="configGradeCloseButton" type="button" data-dismiss="modal"
                    class="btn btn-raised ink-reaction btn-info">{{ 'cancel' | translate }}</button>
                </div>
              </div>
            </div>
          </div>
        </div><!-- /.modal-content -->
      </div><!-- /.modal-dialog -->
    </div><!-- /.modal -->
    <!-- END CREATE EXAM BOARD -->

    <!-- CONFIGURE EXAMS START -->
    <!--<div class="modal fade" id="createExamBoardPopup" tabindex="-1" role="dialog" aria-labelledby="simpleModalLabel" aria-hidden="true">
      <div class="modal-dialog" style="width: 75%;">
        <div class="modal-content">
          <div class="modal-header" style="padding: 0px 25px;">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true" style="margin: 0;margin-top: -1em;background: var(--brand-primary-color);color: white;padding: 20px 15px;box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.33);opacity: inherit;">&times;</button>
            <div class="row">
              <div class="col-md-12" style="text-align:center;margin-top: -1em;">
                <h3 class="text-primary" style="text-transform: uppercase;color:rgb(88, 88, 88);font-weight: 900;margin: 0;"><span style="font-size: 1.5em;margin-right: 10px;color: #656565;border: 1px solid #656565;border-radius: 50%;padding: 10px 13px;"><i class="fa fa-file-text-o"></i></span>School Exam Board</h3>
                <p style="margin: 0;color: #989898;margin-top: -5px;margin-bottom: 10px;">Create exam board here. </p>
              </div>
            </div>
          </div>
          <div class="modal-body" style="background: #fbfbfb;padding: 1px;">
            <div class="row">
              <div class="col-md-12" style="padding: 1em 3em;">
                <form class="form" role="form">
                  <div class="col-md-6 form-group">
                    <input type="text" [(ngModel)]="boardName" name="boardName" class="form-control" placeholder="Enter Board Name">
                    <label style="margin-left: 1em;font-size: 1em;font-weight: 800;color: var(--tertiary-btn-bg-color);">Board Name</label>
                  </div>
                  <div class="col-md-6 form-group">
                    <select id="eval1Type" [(ngModel)]="evalType" (change)="changeEvalType($event.target.value)" name="evalType" class="form-control">
                      <option value="0">Select Type</option>
                      <option value="MARKS">Marks</option>
                      <option value="GRADES">Grades</option>
                      <option value="MARKS_GRADES">Marks & Grades</option>
                    </select>
                    <label for="eval1Type" style="margin-left: 1em;font-size: 1em;font-weight: 800;color: var(--tertiary-btn-bg-color);">Evaluation Type</label>
                  </div>
                  <div class="col-md-12" style="color: #7b7b7b;">
                    <div class="col-md-2">
                      <h4>Class List : </h4>
                    </div>
                    <div class="col-md-6 checkbox checkbox-styled" style="display: inline-block;">
                      <label>
                        <input type="checkbox" [(ngModel)]="allClass" id="selectAllClass" (change)="selectAllClass()" name="selectAll">
                        <span>Select All</span>
                      </label>
                    </div>
                  </div>
                  <div class="col-md-12" id="classList" style="padding: 5px 5px;border: 1px solid gainsboro;overflow: auto">
                    <div class="checkbox checkbox-styled col-md-3" *ngFor="let std of classStandardList" style="display: inline-block;margin: 0px;">
                      <label>
                        <input type="checkbox" [(ngModel)]="std.select" (change)="checkingSelect()" name="{{'className'+std.pkClassStandardsId}}">
                        <span>{{std.ClassStandard}}</span>
                      </label>
                      <span *ngIf="std.select" data-toggle="modal" data-target="#classSection" style="cursor: pointer;color: pink;margin: 12px;font-size: 13px;"><i class="fa fa-clock-o" aria-hidden="true"></i></span>
                    </div>
                  </div>
                </form>
              </div>
              <div class="col-md-12" style="padding: 0px 3em;">
                <div class="col-md-4" style="padding: 10px 0px;">
                  <button type="button" *ngIf="gradeConfigButton" class="btn btn-raised ink-reaction btn-info" (click)="openGradeConfig()" data-toggle="modal" data-target="#gradingSysmtemConfig">Configure Grade System</button>
                </div>
                <div class="col-md-8 text-right" style="padding: 10px 0px;">
                  <button type="button" [disabled]="applyGradingSystem" id="configButton" class="btn btn-raised ink-reaction btn-info" (click)="configExam(classStandardList)">Configure</button>
                  <button type="button" id="cancelconfig" data-dismiss="modal" class="btn btn-raised ink-reaction btn-info">Cancel</button>
                </div>
              </div>

            </div>
          </div>
          <div class="modal-footer" style="text-align: center;background:hsla(207, 84%, 57%, 0);">
            <p style="color: #717171;">© 2017 {{ brand.name }}. All right reserved</p>
          </div>
        </div>&lt;!&ndash; /.modal-content &ndash;&gt;
      </div>&lt;!&ndash; /.modal-dialog &ndash;&gt;
    </div>-->
    <!-- CONFIGURE EXAMS END -->
    <!--VIEW EXAM BOARD CLASS LIST START-->
    <div id="viewExamBoardGradeDetails" class="modal fade" role="dialog">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <h3 class="text-center" style="margin: 0;color: #909090;"><i class="fa fa-bars" style="color: var(--brand-primary-color);"></i>
              {{selectedExamBoardName}} {{ 'boardGradeDetails' | translate }}</h3>
            <button class="  btn ink-reaction btn-floating-action btn-primary" data-dismiss="modal"
              style="background: var(--brand-primary-color);float: right;margin-top: -3em;margin-right: -2em;border: none;"
              type="button">×</button>
            <div class="text-center" style="padding: 1em 1em;">
              <div class="col-md-12 table-responsive" style="padding: 0em 2em;">
                <table class="table table-striped" style="border: 1px solid gainsboro;">
                  <thead>
                    <tr>
                      <th class="text-center">{{ 'marksRange' | translate }}</th>
                      <th class="text-center">{{ 'grade' | translate }}</th>
                      <th class="text-center">{{ 'grade' | translate }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let gd of gradeSystemArray">
                      <td class="text-center">{{gd.MinMarks}} - {{gd.MaxMarks}}</td>
                      <td class="text-center">{{gd.Grade}}</td>
                      <td class="text-center">{{gd.GradePoint}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="text-center">
              <button type="button" class="btn btn-raised ink-reaction btn-info" data-dismiss="modal" aria-hidden="true"
                style="padding: 3px 20px;margin-top: 10px;">{{ 'close' | translate }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--VIEW EXAM BOARD CLASS LIST END-->

    <!-- Offcanvas -->
    <div class="offcanvas">
      <div id="offcanvas-editInfo" class="offcanvas-pane width-12" style="width:800px;    overflow-x: hidden;">
        <div class="offcanvas-head" style="    padding: 0;">
          <div class="col-md-6 text-center" style="background: var(--secondary-btn-bg-color);height: 100%;position: fixed;padding-top: 15em;">

            <img src="{{schoolImage}}" alt="high-school.png" id="schoolimageupload" class="img-responsive"
              style="margin: 0 auto;border-radius: 30px;width: 16em;">
            <div class="col-md-12" style="text-align:center;">
              <div class="col-md-12" style="text-align:center;">
                <h5 class="progress hide" id="schooledit-progressbar"
                  style="text-align: center;cursor: pointer;display: inline-block;border: 1px solid #e2e2e2;padding: 5px 0px;margin: 1em;color: #0aa89e;font-size: 9px;text-transform: uppercase;width: 150px;">
                 {{ 'uploading' | translate }}</h5>
              </div>
              <input type="file" class="input-style" id="openfile" style="width:1px; height: 1px">
              <h5 (click)="openbrowsertoupldphstaff();" class="image-edit hide" id="hideforschool"
                style="text-align: center;cursor: pointer;display: inline-block;border: 1px solid #e2e2e2;padding: 5px 0px;margin: 1em;color: white;font-size: 9px;text-transform: uppercase;width: 150px;">
                {{ 'changeProfileImage' | translate }}</h5>
            </div>
            <h2 style="color:white;margin-top:18px" class="lead">{{updateschool.schoolName}}</h2>
          </div>

          <div class="col-md-6" style="float: right;padding: 40px 20px;margin: 3em 0em;">
            <form class="form" role="form">
              <div class="row" style="margin-left: -2em;">
                <div class=" form-group col-md-3" style="margin-bottom: 20px">
                </div>
                <div class="form-group col-md-12 ">
                  <input type="text" class="form-control" id="busname" [(ngModel)]="updateschool.schoolName"
                    name="schoolDetails" style="font-size: 14px;color:grey;margin-top: -24px;margin-left: 17px;;">
                  <label for="busname" style="margin-top: -26px;margin-left: 30px">{{ 'schoolName' | translate }}</label>
                </div>
              </div>
              <div class="row" style="margin:0;">
                <div class="form-group col-md-5">
                  <input type="number" class="form-control" id="phonenum" [(ngModel)]="updateschool.phoneNumber"
                    name="phonenum" style="font-size: 14px;color:grey;    margin-left: -11px;">
                  <label for="phonenum">{{ 'mobileNumber' | translate }}</label>
                </div>
                <div class="form-group col-md-5 col-md-offset-1">
                  <input type="text" class="form-control" id="drivername" [(ngModel)]="updateschool.emailId"
                    name="emailId" style="font-size: 14px;color:grey;    margin-left: -11px;">
                  <label for="drivername">{{ 'email-id' | translate }}</label>
                </div>
              </div>

              <div class="row" style="margin:0;">
                <div class="form-group" style="padding-left: 0;padding-right: 0;">
                  <input type="text" class="form-control" id="route" [(ngModel)]="updateschool.address" name="address"
                    style="font-size: 14px;color:grey">
                  <label for="route">{{ 'address' | translate }}</label>
                </div>

              </div>
              <div class="row" style="margin:0;">
                <div class="form-group col-md-5" style="padding-left: 0;padding-right: 0;">
                  <input type="text" class="form-control" id="capacity" [(ngModel)]="updateschool.locality"
                    name="locality" style="font-size: 14px;color:grey">
                  <label for="capacity">{{ 'city' | translate }}</label>
                </div>
                <div class="form-group col-md-5 col-md-offset-1" style="padding-left: 0;padding-right: 0;">
                  <input type="text" class="form-control" id="routeid" [(ngModel)]="updateschool.pincode" name="pincode"
                    style="font-size: 14px;color:grey">
                  <label for="route">{{ 'zipCode' | translate }}</label>
                </div>
              </div>

              <div class="form-group " style="padding-left: 0;padding-right: 0;">
                <input type="text" class="form-control" id="routetype" [(ngModel)]="updateschool.description"
                  name="Discription" style="font-size: 14px;color:grey">
                <label for="route">{{ 'description' | translate }}</label>
              </div>



              <div class="col-md-6 " style="margin-left: -11px;">
                <label class="radio-inline radio-styled"
                  style="cursor: initial;   color: #b1b1b1;font-weight: 100;padding-top: 4px;font-size: 12px;">
                  <span>{{ 'parentChatLimit' | translate }}</span>
                </label>
                <div class="col-md-6" style="margin-top: 6px">
                  <label class="radio-inline radio-styled" style="margin-left: -13px">
                    <input [attr.checked]="parentChatStatus ? true : null" type="radio" id="limchatp"
                      (change)="stuChat(true)" name="gendre" class="see-me"><span
                      style="font-size: 12px;">{{ 'limited' | translate }}</span>
                  </label>
                </div>
                <div class="col-md-6" style="margin-top: 6px">
                  <label class="radio-inline radio-styled">
                    <input [attr.checked]="!parentChatStatus ? true : null" type="radio" id="Unlimchtp"
                      (change)="stuChat(false)" name="gendre" class="look-me"><span
                      style="font-size: 12px;">{{ 'unlimited' | translate }}</span>
                  </label>
                </div>
                <div id="dvchatlimit" [class.hidden]="!parentChatStatusInput">
                  <input type="number" id="numchatlimit" value="{{parentChatMessageLimitCount}}" />
                </div>
                <div class="show-me-two col-md-10" style="display:none">
                  <input type="text" class="form-control" [placeholder]="'chatLimit' | translate" style="font-size: 11px;color:grey">
                </div>
              </div>





              <div class="col-md-6 " style="margin-left: 11px;">
                <label class="radio-inline radio-styled"
                  style="cursor: initial;   color: #b1b1b1;font-weight: 100;padding-top: 4px;font-size: 12px;">
                  <span>{{ 'staffChatLimit' | translate }}</span>
                </label>
                <div class="col-md-6" style="margin-top: 6px">
                  <label class="radio-inline radio-styled" style="margin-left: -13px">
                    <input [attr.checked]="staffChatStatus ? true : null" type="radio" id="limchats"
                      (change)="staffChat(true)" name="gendrel" class="see-me1"><span
                      style="font-size: 12px;">{{ 'limited' | translate }}</span>
                  </label>
                </div>
                <div class="col-md-6" style="margin-top: 6px">
                  <label class="radio-inline radio-styled">
                    <input [attr.checked]="!staffChatStatus ? true : null" type="radio" id="Unlimchats" name="gendrel"
                      (change)="staffChat(false)" class="see-me1"><span style="font-size: 12px;">{{ 'unlimited' | translate }}</span>
                  </label>
                </div>
                <div id="dvchatlimitid" [class.hidden]="!staffChatStatusInput">
                  <input type="number" id="numchatlimitst" value="{{staffChatMessageLimitCount}}" />
                </div>
                <div class="show-me-two1 col-md-10" style="display:none">
                  <input type="text" class="form-control" [placeholder]="'chatLimit' | translate" style="font-size: 11px;color:grey">
                </div>
              </div>


              <button type="button" id="updatebtndisable" (click)="updateLatestSchoolDetails()"
                class="btn btn-block ink-reaction btn-info" style="    margin: 11em 0em;">{{ 'updateChanges' | translate }}</button>
            </form>
          </div>
        </div>
      </div>

      <!-- CONFIGURE EXAMS START -->
      <div id="createExamBoardPopup_V2" class="offcanvas-pane width-12" style="width:800px;    overflow-x: hidden;">
        <div class="offcanvas-head">
          <div class="row" style="background: var(--secondary-btn-bg-color);height: 3em;">
            <div class="row">
              <div class="col-md-12 text-center" style="position: fixed;color: white;">
                <div class="col-md-11 text-center">
                  <h4>{{ 'educationalBoard' | translate }}</h4>
                </div>
                <div class="col-md-1" style="z-index: 999;margin-top: -1em;">
                  <h3 class="pull-right" style="color: white;cursor: pointer;" data-dismiss="offcanvas"><i
                      class="fa fa-close"></i></h3>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12" style="padding: 1em 0em;">
              <form class="form" role="form">
                <div class="col-md-6 form-group">
                  <input type="text" [(ngModel)]="boardName" name="boardName" class="form-control"
                    [placeholder]="'enterBoardName' | translate">
                  <label style="margin-left: 1em;font-size: 1em;font-weight: 800;color: var(--tertiary-btn-bg-color);">{{ 'boardName' | translate }}</label>
                </div>
                <div class="col-md-6 form-group">
                  <select id="eval1Type" [(ngModel)]="evalType" (change)="changeEvalType($event.target.value)"
                    name="evalType" class="form-control">
                    <option value="0">{{ 'selectType' | translate }}</option>
                    <option value="MARKS">{{ 'marks' | translate }}</option>
                    <option value="GRADES">{{ 'grades' | translate }}</option>
                    <option value="MARKS_GRADES">{{ 'marksGrades' | translate }}</option>
                  </select>
                  <label for="eval1Type"
                    style="margin-left: 1em;font-size: 1em;font-weight: 800;color: var(--tertiary-btn-bg-color);">{{ 'evaluationType' | translate }}</label>
                </div>
                <div class="col-md-12" style="color: #7b7b7b;">
                  <div class="col-md-2">
                    <h4>{{ 'classList' | translate }} </h4>
                  </div>
                  <div class="col-md-6 checkbox checkbox-styled" style="display: inline-block;">
                    <label>
                      <input type="checkbox" [(ngModel)]="allClass" id="selectAllClass" (change)="selectAllClass()"
                        name="selectAll">
                      <span>{{ 'selectAll' | translate }}</span>
                    </label>
                  </div>
                </div>
                <div class="col-md-12 table-responsive" id="classList"
                  style="border: 1px solid gainsboro;overflow: auto">
                  <div class="col-md-12" style="padding: 10px 0px;">
                    <div class="col-md-2"><b>{{ 'classList' | translate }}</b></div>
                    <div class="col-md-10"><b>{{ 'sectionList' | translate }}</b></div>
                  </div>
                  <table class="table ">
                    <tbody>
                      <tr *ngFor="let std of classAndSectionList" style="border-bottom: 1px solid gainsboro;">
                        <td class="col-md-2" style="border-right: 1px solid gainsboro;">
                          <label class="checkbox checkbox-styled">
                            <input type="checkbox" [(ngModel)]="std.select" id="{{'className'+std.ClassStandardsId}}"
                              (change)="selectAllSectionOfClass(std.section);checkingSelect()"
                              name="{{'className'+std.ClassStandardsId}}">
                            <span>{{std.classStandardName}}</span>
                          </label>
                        </td>
                        <td *ngFor="let sec of std.section">
                          <label class="checkbox checkbox-styled">
                            <input type="checkbox" [(ngModel)]="sec.select"
                              (change)="checkingSelectSection(std.section)" name="{{'section'+sec.classId}}">
                            <span>{{sec.classDivision}}</span>
                          </label>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </form>
            </div>
            <div class="col-md-12" style="padding: 0px 3em;">
              <div class="col-md-4" style="padding: 10px 0px;">
                <button type="button" *ngIf="gradeConfigButton" class="btn btn-raised ink-reaction btn-info"
                  data-toggle="modal" data-target="#gradingSysmtemConfig">{{ 'configureGradeSystem' | translate }}</button>
              </div>
              <div class="col-md-8 text-right" style="padding: 10px 0px;">
                <button type="button" [disabled]="applyGradingSystem" id="configButton"
                  class="btn btn-raised ink-reaction btn-info" (click)="configExamBoard()">{{ 'configure' | translate }}</button>
                <button type="button" id="cancelconfig" data-dismiss="offcanvas"
                  class="btn btn-raised ink-reaction btn-info">{{ 'cancel' | translate }}</button>
              </div>
            </div>

          </div>
        </div><!-- /.modal-dialog -->
      </div>
      <!-- CONFIGURE EXAMS END -->
      <!--VIEW EXAM BOARD CLASS LIST START-->
      <div id="offcanvasViewExamBoard" class="offcanvas-pane width-12" style="width:850px;overflow-x: hidden;">
        <div class="offcanvas-head" style="    padding: 0;">
          <!-- Student details -->
          <div id="particles-view-student" class="row" style="background: var(--secondary-btn-bg-color);min-height: 200px;">
            <div class="particles-content">
              <div class="col-md-12" style="position: fixed;z-index: 999;top: 0em;">
                <h3 class="pull-right" style="color: white;cursor: pointer;" data-dismiss="offcanvas"><i
                    class="fa fa-close"></i></h3>
              </div>
              <div class="col-md-12 text-center" style="padding: 1em 0px;">
                <p class="lead text-center"
                  style="color: #ffffff;text-transform: uppercase; letter-spacing: 1px;margin-bottom: 10px;">
                  {{selectedExamBoardName}} {{ 'boardDetails' | translate }}</p>
                <img src="images_ext/test.png" class="img-responsive" style="margin: 0 auto;width: 75px;">
                <p style="margin: 15px 0px; color: white; font-weight: 100;">{{ 'viewExamBoardClassDetailsHere' | translate }}</p>
              </div>
            </div>
          </div>
          <div class="row" style="background: #f1f1f1;">
            <div class="col-md-12">
              <h4 class="lead pull-left"
                style="margin: 10px 10px;color: #888888;letter-spacing: 1px;font-size: 12px;text-transform: uppercase;">
                {{ 'examBoardDetails' | translate }}</h4>
              <div style="position: absolute;float: inherit;width: inherit;right: 2em;top: -12px;">
                <button *ngIf="boardEvaluationType != 'MARKS'" type="button" data-toggle="modal"
                  data-target="#viewExamBoardGradeDetails" (click)="getExamGradeConfigByExamBoard(selectedExamBoardId)"
                  class="pull-right btn ink-reaction btn-floating-action btn-primary"
                  style="background: #E91E63;border: none;width: 60px;height: 60px;"><i class="fa fa-eye"></i></button>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12" style="padding: 15px 25px;">
              <div class="col-md-12 table-responsive" style="padding: 0em 2em;border: 1px solid gainsboro;">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th>{{ 'classList' | translate }}</th>
                      <th id="tableSectionHeader">{{ 'sectionList' | translate }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let std of classListByExamBoard">
                      <td>{{std.classStandarName}}</td>
                      <td *ngFor="let obj of std.classList">{{obj.classDivision}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--VIEW EXAM BOARD CLASS LIST END-->
    </div>
    <!-- ///// -->

  </div>
  <!--end #base-->
  <!-- END BASE -->

</div>